/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { InvitationsControllerUpdateMutationRequest, InvitationsControllerUpdateMutationResponse, InvitationsControllerUpdatePathParams, InvitationsControllerUpdate400, InvitationsControllerUpdate401, InvitationsControllerUpdate403, InvitationsControllerUpdate404 } from "../../models/invitationsController/InvitationsControllerUpdate";

function getInvitationsControllerUpdateUrl(id: InvitationsControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/invitations/${id}` as const }  
  return res
}

/**
 * @description Updates an existing invitation (role or message).
 * @summary Update invitation
 * {@link /api/v1/invitations/:id}
 */
export async function invitationsControllerUpdate(id: InvitationsControllerUpdatePathParams["id"], data?: InvitationsControllerUpdateMutationRequest, config: Partial<RequestConfig<InvitationsControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<InvitationsControllerUpdateMutationResponse, ResponseErrorConfig<InvitationsControllerUpdate400 | InvitationsControllerUpdate401 | InvitationsControllerUpdate403 | InvitationsControllerUpdate404>, InvitationsControllerUpdateMutationRequest>({ method : "PATCH", url : getInvitationsControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}